export enum StoryComponentType {
  StoriesFullWidth = "storiesFullWidth",
  StoriesTextAndImageRight = "storiesTextAndImageRight",
  StoriesCallToAction = "storiesCallToAction",
}
